<form [formGroup]="paymentPrepForm" novalidate>
    <ng-template #summary>
        <div class="summary-div">
            <h5>ORDER SUMMARY</h5>
            <table class="summary-tab">
                <tr>
                    <td colspan="3">TREES</td>
                </tr>
                <tr *ngFor="let t of summaryTrees">
                    <td>{{t.qty}}</td>
                    <td>{{t.treeCommonName}}</td>
                    <td class="price">{{t.total | currency}}</td>
                </tr>
                <tr>
                    <td colspan="2"><span>DONATION</span></td>
                    <td class="price">{{f.donationAmount.value | currency}}</td>
                </tr>
                <tr *ngIf="campaign.askForMulchFee">
                    <td colspan="2"><span>MULCH FEE</span></td>
                    <td class="price">{{request.mulchFee | currency}}</td>
                </tr>
                <tr>
                    <td colspan="2">SUB-TOTAL</td>
                    <td class="price">{{request.treeTotalAmount + f.donationAmount.value | currency}}</td>
                </tr>
                <tr>
                    <td colspan="3"><span style="color:#4A6F2A">Coupon code</span></td>
                </tr>
                <tr>
                    <td colspan="3">
                        <div class="form-group short-field">
                            <input id="couponCode" type="text" class="form-control" formControlName="couponCode">
                            <div style="color: red;">{{couponMessageInvalid}}</div>
                            <!-- <div style="color: blue;">{{couponMessage}}</div> -->
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" style="font-weight: bold;">TOTAL CHARGES TODAY</td>
                    <td style="font-weight: bold;" class="price">{{request.amountDueNow | currency}}</td>
                </tr>
            </table>
            <table class="summary-tab" *ngIf="summaryTreesWait.length>0">
                <tr>
                    <td colspan="3">WAITLIST*</td>
                </tr>
                <tr *ngFor="let t of summaryTreesWait">
                    <td>{{t.qty}}</td>
                    <td>{{t.treeCommonName}}</td>
                    <td class="price">{{t.total | currency}}</td>
                </tr>
                <!-- <tr>
                    <td></td>
                    <td>Waitlisted trees*</td>
                    <td class="price">{{request.waitListAmount | currency}}</td>
                </tr> -->
                <tr>
                    <td colspan="3">
                        <p style="font-size: smaller;">
                            ‘*Total to be charged when/if waitlisted trees become available. This amount will not be
                            charged unless you are awarded a tree/s. Please note: if you requested multiple waitlist
                            trees, charges may occur over multiple dates, depending on when/if trees become available
                        </p>
                    </td>
                </tr>
            </table>
        </div>
    </ng-template>
    <div>
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="row">
                    <div class="col-sm-auto">
                        <div class="form-group short-field">
                            <label for="donationAmount" class="control-label green-label">
                                <span style="color:#4A6F2A;font-size: 1.5rem;;font-weight: 500;">Donation</span></label>
                            <input id="donationAmount" type="number" class="form-control" style="width:110px"
                                formControlName="donationAmount">
                        </div>
                    </div>
                    <div class="col-sm">
                        <p class="rtext">
                            <!-- YOU can support trees for low-canopy neighborhoods and for households with a financial
                            hardship! -->
                            I got this! I can chip in extra to keep trees cheap for all Denverites. Enter the dollar
                            amount of your tax-deductible donation.
                        </p>
                    </div>
                </div>
                <div class="row" *ngIf="campaign.askForMulchFee">
                    <div class="col-sm-auto">
                        <div class="form-group short-field">
                            <div class="form-check float-right">
                                <input id="addMulch" type="checkbox" class="form-check-input" [checked]="mulchAdded"
                                    (click)="addMulch()" formControlName="addMulch" />
                            </div>
                        </div>
                    </div>
                    <div class="col-sm">
                        <p>
                            Yes! I'll cover the cost of mulch for my trees.
                        </p>
                    </div>
                </div> <!-- <div class="row">
                        <div class="col-sm-auto">
                            <div class="form-group short-field">
                                <label for="treeTotalAmount" class="control-label green-label">Tree Total</label>
                                <div class="ltext">{{request.treeTotalAmount | currency}}</div>
                              </div>
                        </div>
                        <div class="col-sm">
                            <p class="rtext">
                                Based on your Neighborhood of your planting address thir is the cost for your tree(s) that you
                                are
                                requesting.
                            </p>
                        </div>
                    </div> -->
                <h4>Billing Information</h4>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="firstNameCard" class="control-label">First Name on Card</label>
                            <input id="firstNameCard" type="text" class="form-control" formControlName="firstNameCard"
                                [attr.disabled]="disableBill ? true : null">
                            <div *ngIf="f.firstNameCard.invalid && (f.firstNameCard.dirty || f.firstNameCard.touched)"
                                class="form-text text-danger">
                                <div *ngIf="f.firstNameCard.errors.required">First Name on Card is required.</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="lastNameCard" class="control-label">Last Name</label>
                            <input id="lastNameCard" type="text" class="form-control" formControlName="lastNameCard"
                                [attr.disabled]="disableBill ? true : null">
                            <div *ngIf="f.lastNameCard.invalid && (f.lastNameCard.dirty || f.lastNameCard.touched)"
                                class="form-text text-danger">
                                <div *ngIf="f.lastNameCard.errors.required">Last Name on Card is required.</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-check">
                        <input id="sameAsMail2" type="checkbox" class="form-check-input" formControlName="sameAsMail2"
                            [attr.disabled]="disableBill ? true : null">
                        <label class="form-check-label" for="sameAsMail2">The same as mailing address</label>
                    </div>
                </div>

                <div class="form-group">
                    <label for="billingAddress" class="control-label">Billing Address<span class="req-field"> *
                        </span></label>
                    <input id="billingAddress" type="text" class="form-control" formControlName="billingAddress"
                        autocomplete="chrome-off" [attr.disabled]="disableAddress || disableBill ? true : null">
                    <div *ngIf="f.billingAddress.invalid && (f.billingAddress.dirty || f.billingAddress.touched)"
                        class="form-text text-danger">
                        <div *ngIf="f.billingAddress.errors.required">billing Address is required.</div>
                        <div *ngIf="f.billingAddress.errors.maxlength">Exceeds maximum length limit</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 ">
                        <div class="form-group">
                            <label for="billingCity" class="control-label">City<span class="req-field"> *
                                </span></label>
                            <input id="billingCity" type="text" class="form-control" formControlName="billingCity"
                                [attr.disabled]="disableAddress || disableBill ? true : null">
                            <div *ngIf="f.billingCity.invalid && (f.billingCity.dirty || f.billingCity.touched)"
                                class="form-text text-danger">
                                <div *ngIf="f.billingCity.errors.required">billing City is required.</div>
                                <div *ngIf="f.billingCity.errors.maxlength">Exceeds maximum length limit</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 ">
                        <div class="form-group">
                            <label for="billingState" class="control-label">State<span class="req-field"> *
                                </span></label>
                            <select class="form-control" id="billingState" formControlName="billingState"
                                [attr.disabled]="disableAddress || disableBill ? true : null">
                                <option style="display:none">
                                <option *ngFor="let s of logic.stateLabelValues" [ngValue]="s.label">{{s.value}}
                                </option>
                            </select>
                            <div *ngIf="f.billingState.invalid && (f.billingState.dirty || f.billingState.touched)"
                                class="form-text text-danger">
                                <div *ngIf="f.billingState.errors.required">billing State is required.</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 ">
                        <div class="form-group">
                            <label for="billingZip" class="control-label">Zip<span class="req-field"> * </span></label>
                            <input id="billingZip" type="text" class="form-control" formControlName="billingZip"
                                [attr.disabled]="disableAddress || disableBill ? true : null" [appDigitMask]="5">
                            <div *ngIf="f.billingZip.invalid && (f.billingZip.dirty || f.billingZip.touched)"
                                class="form-text text-danger">
                                <div *ngIf="f.billingZip.errors.required">Zip is required.</div>
                                <div *ngIf="f.billingZip.errors.minlength">Must be 5 digits.</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-lg-none">
                    <div *ngTemplateOutlet="summary">
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="cardNumber" class="control-label">Card Number</label>
                            <input id="cardNumber" type="text" class="form-control" formControlName="cardNumber"
                                [attr.disabled]="disableBill ? true : null" [appDigitMask]="20">
                            <div *ngIf="f.cardNumber.invalid && (f.cardNumber.dirty || f.cardNumber.touched)"
                                class="form-text text-danger">
                                <div *ngIf="f.cardNumber.errors.required">Card # is required.</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="expirationDate" class="control-label">Expiration Date</label>
                            <div class="input-group">
                                <input id="expirationDate" type="text" class="form-control"
                                    [attr.disabled]="disableBill ? true : null" formControlName="expirationDate"
                                    appMmYyMask>
                            </div>
                            <div *ngIf="f.expirationDate.invalid && (f.expirationDate.dirty || f.expirationDate.touched)"
                                class="form-text text-danger">
                                <div *ngIf="f.expirationDate.errors.required">Expiration Date is required.</div>
                                <!-- <div *ngIf="f.expirationDate.errors.pattern">Must be MM/YY or MM/YYYY</div> -->
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="cvv" class="control-label">CVV</label>
                            <input id="cvv" type="text" class="form-control" formControlName="cvv" [appDigitMask]="4"
                                [attr.disabled]="disableBill ? true : null">
                            <div *ngIf="f.cvv.invalid && (f.cvv.dirty || f.cvv.touched)" class="form-text text-danger">
                                <div *ngIf="f.cvv.errors.required">CVV is required.</div>
                                <div *ngIf="f.cvv.errors.minlength">Must be 3 or 4 digits</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-lg-4 d-none d-lg-block">
                <div *ngTemplateOutlet="summary">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-8">
            </div>
            <div class="col-lg-4"></div>
        </div>
        <!-- <div class="row">
                <div class="col-sm-auto">
                    <div class="form-group short-field">
                        <label for="amountDueNow" class="control-label green-label">Amount Due Now</label>
                        <div class="ltext">{{request.amountDueNow | currency}}</div>
                        <div style="color: blue;">{{couponMessage}}</div>
                    </div>
                </div>
                <div class="col-sm">
                 </div>
            </div> -->
        <!-- <div class="row">
                <div class="col-sm-auto">
                    <div class="form-group short-field">
                        <label for="waitListAmount" class="control-label green-label">
                            Wait List Amount
                            <a class="infolink"
                                ngbPopover="'Total to be charged if and when waitlist trees become available.  This amount will not be charged unless you are awarded waitlist trees. Please note: if you requested multiple waitlist trees, charges may occur over multiple dates, depending on when trees become available '"
                                triggers="click" popoverTitle="Waitlist Trees" container="body"
                                style="margin: 5px 5px 0 5px">
                            </a>

                        </label>
                        <div class="ltext">
                            {{request.waitListAmount | currency}}
                        </div>
                     </div>
                </div>
                <div class="col-sm">
 
                </div>
            </div> -->
    </div>

    <div style="margin-top: 30px;">
        <button type="button" class="btn btn-warning btn-lg" (click)="placeOrderClick()" *ngIf="!isSubmitted"
            [attr.disabled]="isValid() ? null : true">Submit Application</button>
        <span *ngIf="isSubmitted" style="color: #4A6F2A;font-size: large;"> Your payment is being processed</span>
        <p *ngIf="cardErrorMessage" style="color: red;font-size: large;">{{cardErrorMessage}}</p>
    </div>
</form>